import { IconButton } from 'Components/Button';
import { Row,Col,Image,Stack, Button, Form } from 'react-bootstrap';
import { createPortal } from 'react-dom';
import { ICONS } from 'Utils/icons';


function SearchInput({ 
    itemLocation, 
    setIsFocusBase, 
    hasBtnFocus, 
    setHasBtnFocus, 
    formBtnRef, 
    formRef, 
    setShowFloatingDropdown, 
    setSearchTerm, 
    searchTerm,  
    getSearchData, 
    isSticky, 
    hasFocus, 
    setHasFocus,
    setOpenBtnFocus,
    setSearchBarFocus,
    setSearchBtnFocus,
    openBtn,
    searchBar,
    searchBtn
}) {
    
    const handleFocusLocation = () => {
        if(itemLocation=='fixed'){
            setIsFocusBase(false);
        }
        else{
            setIsFocusBase(true);
        }
    }

    const verifyInput = (text) =>{
        if(text!=null && text!=""){
            var value = text.trim();
            //if(value.length < 1){
                //console.log(value);
            //}
            //else{

            //}
        }
    }
    return (
        

        <Form 
            //ref={formRef} 
            className={"search-form " + (itemLocation=='fixed' ? "p-2" : "p-0")}  
            role="search" 
            aria-label="Event Descriptions"
            
        >
            <Form.Group id="" className="g-0 d-flex flex-row flex-nowrap flex-md-nowrap flex-md-row gap-0">
                <Col className="d-flex flex-column  g-0 position-relative">
                
                    <div className="d-flex flex-row align-items-center g-0 lh-1">
                        <Form.Control
                            key={"searchBar"+itemLocation}
                            ref={searchBar} 
                            value={searchTerm} 
                            onChange={(e)=>{
                                var val = e.target.value;
                                setSearchTerm(val);
                            }} 
                            onKeyDown={(e)=>{
                                if(e.code==="Enter"){
                                    verifyInput(searchTerm);
                                    e.preventDefault();
                                    getSearchData(searchTerm);
                                    setShowFloatingDropdown(true);       
                                    setSearchBarFocus(true)
                                    setHasFocus(true);    
                                }
                            }}
                            onFocus={(e) => {
                                //console.log(e);
                                handleFocusLocation();
                                setSearchBarFocus(true)
                                setHasFocus(true);
                            }}
                            onBlur={(e) => {
                                //console.log("blur",e);
                                setHasFocus(false);
                                setSearchBarFocus(false);
                            }}
                            //autoFocus={hasFocus}
                            className={isSticky==true ? "m-0  sticky-indicator":"m-0 "}
                            id="searchFieldCT" 
                            role="searchbox" 
                            aria-label="Search event descriptions" 
                            placeholder="Search event descriptions" 
                        >
                        </Form.Control>
                        <IconButton 
                            title="Search event descriptions"
                            key={"searchBtn"+itemLocation}
                            ref={searchBtn} 
                            variant="comp-secondary" 
                            content={'Search'} 
                            id=""
                            hiddenText="Search"
                            className="d-flex mt-sm-0  mb-0 justify-content-center align-items-center body semibold h-100" 
                            onClick={()=>{
                                verifyInput(searchTerm);
                                handleFocusLocation();
                                getSearchData(searchTerm);
                                //setSearchBtnFocus(true);  
                                setShowFloatingDropdown(true);    
                                setSearchBtnFocus(true);
                                
                            }}
                            //autoFocus={hasBtnFocus}
                            icon={ICONS.search()}
                            onFocus={(e) => {
                                //console.log(e);
                                handleFocusLocation();
                                setHasBtnFocus(true);
                                setSearchBtnFocus(true);
                            }}
                            onBlur={(e) => {
                                //console.log(e);
                                setHasBtnFocus(false);
                                setSearchBtnFocus(false);
                            }}
                        />
                    </div>

                </Col>
            </Form.Group>
        </Form>
        
    );
}

export default SearchInput;